import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlToText',
  standalone: true,
})
export class HtmlToTextPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    const spaced = value.replace(/<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi, ' ');
    const text =
      new DOMParser().parseFromString(spaced, 'text/html').body.textContent ??
      '';
    return text.replace(/\s+/g, ' ').trim();
  }
}
